import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

import type { PaymentFormAdapterLookupFunction } from '../types/PaymentFormAdapterLookupFunction'

import { PAYMENT_FORM_ADAPTERS } from './adapters'

/**
 * Each payment method has a corresponding adapter component that will be used to render the payment form.
 * This function returns the adapter corresponding to the given payment method.
 */
export const getMethodCorrespondingAdapter: PaymentFormAdapterLookupFunction = (
  method: PaymentMethod | null,
) => {
  if (!method) {
    // NOOP adapter
    // To avoid having to check if the component is defined before rendering it
    return () => null
  }

  const { pspCode, bmCode, integrationType } = method

  const type = integrationType ?? 'DEFAULT'

  return (
    PAYMENT_FORM_ADAPTERS[pspCode][bmCode]?.[type] ||
    PAYMENT_FORM_ADAPTERS[pspCode][bmCode]?.DEFAULT ||
    PAYMENT_FORM_ADAPTERS[pspCode].DEFAULT[type] ||
    PAYMENT_FORM_ADAPTERS[pspCode].DEFAULT.DEFAULT
  )
}
